import { el, text, type RedomComponent } from "redom"
import { RecordItem, RecordItemWithImage } from "./record-item.js"
import RecordTable from "./record-table.js"
import { setCollapseRecordList, getShowMoreText } from "../helpers/collapse.js"
import type { CollapseListData, RecordsSectionCtx } from "#/types"

export default class CollapseList implements RedomComponent {
    private records: RecordTable
    mainDiv: HTMLDivElement
    border: HTMLHeadingElement = el("h3.border-bottom.noMargin")
    private showMore: Text = text("Show more");
    private collapseButton: HTMLParagraphElement = el("p.collapseListItem.clickable", el("i.fas fa-angle-down collapseIcon"), this.showMore)
    collapser: HTMLAnchorElement = el("a.collapsed", {"data-bs-toggle": "collapse", role: "button", "aria-expanded": "false", style: "display:none" }, this.collapseButton)
    el: HTMLDivElement
    constructor(tableType: Constructor<RecordItem> = RecordItemWithImage) {
        this.records = new RecordTable(tableType)
        this.mainDiv = el(".noSpace.collapse", this.border, this.records)
        this.el = el("div", this.mainDiv, this.collapser)
        if (tableType == RecordItemWithImage) this.border.style.marginLeft = "75px"
    }
    init(data: CollapseListData, context: RecordsSectionCtx = {}) {
        const items = data.items
        const collapseName = data.collapseName + "Collapse"
        const amountOfMore = data.numberBefore ?? 0
        this.collapser.style.display = (items.length > 0 || data.showMoreButton) ? "block" : "none" // Add button if we have items
        this.border.style.display = items.length > 0 ? "block" : "none"// Hide the line on the update with records section without collapse-list
        this.collapser.dataset.bsTarget = ".multi-collapse-" +  collapseName
        this.collapser.setAttribute("aria-controls", collapseName + "Top " + collapseName)
        this.mainDiv.classList.add("multi-collapse-" + collapseName)
        this.collapseButton.id = data.collapseName + "BtnCollapse"
        this.showMore.textContent = getShowMoreText("record", amountOfMore + items.length)
        this.mainDiv.id = collapseName
        this.records.init(items, context)
        setCollapseRecordList(data.collapseName ?? "", amountOfMore + items.length)
    }
}